import { render, staticRenderFns } from "./RequestItem.vue?vue&type=template&id=2140f003&scoped=true"
import script from "./RequestItem.vue?vue&type=script&lang=js"
export * from "./RequestItem.vue?vue&type=script&lang=js"
import style0 from "./RequestItem.vue?vue&type=style&index=0&id=2140f003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2140f003",
  null
  
)

export default component.exports